<ul class='tabs'>
  @for (tab of tabs; track tab) {
    <li [class.active]='tab.active' [class.inverse]='this.inverse' [class.invalid]='tab.invalid' (click)="selectTab(tab)">{{ tab.title }}</li>
  }
</ul>
<ng-content></ng-content>
